import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { FileExplorerService } from './file-explorer.service';
import { TcmModalService } from '../../../../modules/tcm-common/services/tcm-modal.service';

@Component({
    selector: 'file-explorer',
    templateUrl: './file-explorer.component.html',
    styleUrls: ['./file-explorer.component.scss'],
    standalone: false
})

export class FileExplorerComponent implements OnInit {

  @ViewChild('createFolderModalTemplate', { static: true }) createFolderModalTemplate: TemplateRef<any>;

  @Input() patientId: string;
  @Input() canEdit: boolean;

  constructor(public fileExplorerService: FileExplorerService, private modalSvc: TcmModalService) {
  }

  ngOnInit() {
    this.fileExplorerService.setupRoot(this.patientId);
  }

  async openAddFolderPopup() {

    const data = {
      folderName: null as string
    };

    const creationConfirmed = await this.modalSvc.showActionModalAsync<boolean>(x => x.Screens.FileExplorer.Fields.CreateFolder, this.createFolderModalTemplate, "sm",
      [
        { title: x => x.Screens.FileExplorer.Actions.Create, value: true, cssClass: 'complete', requireValidForm: true },
        { title: x => x.Common.SearchActionsAndDetailsActions.Cancel, value: false, cssClass: 'default', isDefault: true }
      ], data);

    if (creationConfirmed === true && data.folderName) {
      await this.fileExplorerService.addFolderAsync(data.folderName);
    }
  }
}
